import { render, staticRenderFns } from "./ListItemsList.vue?vue&type=template&id=879ecbda&"
import script from "./ListItemsList.vue?vue&type=script&lang=ts&"
export * from "./ListItemsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports